import React from 'react'
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

export default function Page404() {
  return (
    <div style={{ height: "90vh" }}>
      <DotLottieReact
        src="https://lottie.host/4fafe3f4-df71-43a1-a9f6-5da929719cf1/FpvMB3Z8Rf.lottie"
        loop
        autoplay
      />

    </div>
  )
}
